<template>
  <v-dialog v-model="show" max-width="800px" class="chat-dialog bordered elevation-1 pa-0 ">
    <v-card>
      <v-card-title class="headline black--text d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <div class="mr-2">
            <v-avatar size="44">
              <img v-if="item && item.user && item.user.avatar" :src="item.user.avatar" />
              <v-icon v-else>mdi-account</v-icon>
            </v-avatar>
          </div>
          <div class="d-flex flex-column align-start">
            <span class="mr-2 font-weight-bold text--black subtitle-1">
              Historial de conversación
            </span>
            <span class="font-weight-light" v-if="item && item.user">
              {{ item.user.name }}
            </span>
          </div>
        </div>
        <v-btn icon small @click="close" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4 chat-container" ref="chatContainer">
        <template v-if="item && item.messages">
          <div v-for="(message, index) in item.messages" :key="`msg-${index}`">
            <!-- Date divider -->
            <div v-if="shouldShowDate(index)" class="date-divider">
              {{ formatDateHeader(message.created_at) }}
            </div>

            <!-- Message bubble -->
            <div class="message-wrapper" :class="[!isAgentMessage(message.from_name) ? 'user-message' : 'ai-message']">
              <div class="message-bubble">
                <div class="message-content" v-html="formatMessage(message.message)"></div>
                <div class="message-time">{{ formatTime(message.created_at) }}</div>
              </div>
            </div>
          </div>
        </template>
      </v-card-text>

      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">
          Cerrar
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import axios from '@/axios.js';

export default {
  name: 'ChatMessagesModal',
  props: {
    value: Boolean,
    item: {
      type: Object,
      default: () => ({
        user: {},
        messages: []
      })
    }
  },
  data() {
    return {
      agents: []
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },

    groupedMessages() {
      return this.item.messages;
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    }
  },

  methods: {
    async fetchAgents() {
      this.loading = true;
      try {
        const response = await axios.get('/admin/get-agents', {
          params: {
            page: this.page,
            per_page: this.perPage,
            search: this.search,
            order_by: this.orderBy,
            order_direction: this.orderDirection,
            filter: this.agentType
          }
        });

        this.agents = response.data.agents.data;
        this.totalFiltered = response.data.agents.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.show = false;
    },

    formatMessage(text) {
      if (!text) return '';
      
      // 1. Escapar HTML
      let html = text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');

      // 2. Encabezados markdown (### Título) → negrilla
      html = html.replace(/^#{1,6}\s+(.+)$/gm, '<br><strong>$1</strong><br>');

      // 3. Separar elementos de lista inline:
      //    "texto. - Otro" o "texto: - Otro" → salto con espacio antes del guion
      html = html.replace(/([.!?:])\s+- /g, '$1<br><br>- ');

      // 4. Separar listas numeradas inline:
      //    "texto. 2. Otro" o "texto. 2) Otro" → salto con espacio antes del número
      html = html.replace(/([.!?:])\s+(\d+)\.\s/g, '$1<br><br>$2. ');
      html = html.replace(/([.!?:])\s+(\d+)\)\s/g, '$1<br><br>$2) ');

      // 5. Convertir listas con guion "- Item" → bullet "• Item"
      html = html.replace(/^- /gm, '• ');
      html = html.replace(/<br>- /g, '<br>• ');

      // 6. Harmony Fan en negrilla
      html = html.replace(/Harmony Fan/g, '**Harmony Fan**');

      // 7. Negrilla markdown **texto** → <strong>
      html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

      // 8. Saltos de línea
      html = html.replace(/\n/g, '<br>');

      // 9. Espaciado entre elementos de lista (línea en blanco antes de cada item)
      html = html.replace(/<br>(\d+\.\s)/g, '<br><br>$1');
      html = html.replace(/<br>(\d+\)\s)/g, '<br><br>$1');
      html = html.replace(/<br>(•\s)/g, '<br><br>$1');

      // 10. Limpiar <br> excesivos (máximo 2 seguidos)
      html = html.replace(/(<br>\s*){3,}/g, '<br><br>');

      return html;
    },

    formatTime(date) {
      return moment(date).format('HH:mm');
    },

    formatDateHeader(date) {
      return moment(date).format('DD MMMM, YYYY');
    },

    shouldShowDate(index) {
      if (!this.item || !this.item.messages || !this.item.messages.length) return false;
      if (index === 0) return true;
      const currentDate = moment(this.item.messages[index].created_at).startOf('day');
      const prevDate = moment(this.item.messages[index - 1].created_at).startOf('day');
      return !currentDate.isSame(prevDate);
    },

    updateMessageTime(message) {
      this.$emit('update-time', message);
    },

    scrollToBottom() {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    isAgentMessage(messageName) {
      if (!messageName || !this.agents.length) return false;
      return this.agents.some(agent => agent.name === messageName);
    }
  },

  mounted() {
    this.scrollToBottom();
    this.fetchAgents();
  }
};
</script>

<style scoped>
.chat-dialog {
  border-radius: 18px;
}

.close-btn {
  background-color: #f1ebff;
  color: #ffffff;
}

.chat-container {
  max-height: 60vh;
  overflow-y: auto;
  background-color: #f0f2f5;
  padding: 16px;
  scroll-behavior: smooth;
}

.date-divider {
  text-align: center;
  color: #666;
  font-size: 0.9em;
  margin: 16px 0;
  position: relative;
  background: white;
  width: fit-content;
  margin: 16px auto;
  padding: 4px 12px;
  border-radius: 8px;
}

.message-wrapper {
  display: flex;
  margin-bottom: 8px;
}

.message-bubble {
  min-width: 100px;
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
}

.message-content {
  text-align: start;
  word-wrap: break-word;
  margin-bottom: 4px;
}

.message-transmitter {
  font-weight: bold;
  margin-bottom: 4px;
}


.message-time {
  font-size: 0.75em;
  color: #667781;
  text-align: right;
  cursor: pointer;
}

.user-message {
  justify-content: flex-end;

  .message-bubble {
    background-color: #e0d3fd;
  }
}

.ai-message {
  justify-content: flex-start;

  .message-bubble {
    background-color: white;
  }
}

.headline {
  line-height: 1;
  font-size: small !important;
  background-color: #fff !important;
  padding: 16px !important;
}
</style>